import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const paymentConfig = {
    amount: 0,
    dynamicAmount: true,
    dynamicField: 'tipoServicoAlteracaoNome',
    options: {
        'CARTÃO_NOVO_CARTEIRA_NOVA': {
            name: 'Cartão Novo + Carteira Nova',
            amount: 164.00,
            description: 'Emissão de novo cartão com carteira nova'
        },
        'CARTÃO_NOVO_AVERBAÇÃO': {
            name: 'Cartão Novo + Averbação na Carteira (Brochura)',
            amount: 140.00,
            description: 'Averbação na carteira existente (brochura)'
        }
    }
};

const protocoloConfig = {
    modeloRequerimento: {
        field: paymentConfig.dynamicField,
        map: { 'CARTÃO_NOVO_CARTEIRA_NOVA': '280', 'CARTÃO_NOVO_AVERBAÇÃO': '294' }
    },
    tiposAssunto: '824',
    tipoPedido: '480'
};

// Confirmado ao vivo: 280 e 294 têm o mesmo shape (Nome/CPFCNPJ + endereço residencial, sem email).
const dadosRequerimentoConfig = mergeDadosRequerimentoConfig(
    {
        campos: [
            { field: 'nomeCompleto', campoNome: 'Nome' },
            { field: 'cpf', campoNome: 'CPFCNPJ' }
        ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
);

const tituloConfig = {
    tipoLancamentoId: {
        field: paymentConfig.dynamicField,
        map: { 'CARTÃO_NOVO_CARTEIRA_NOVA': 152, 'CARTÃO_NOVO_AVERBAÇÃO': 151 }
    },
    enderecoOrigem: 'residencial'
};

const pedidoAlteracaoNomeConfig = {
    id: 'pedido_AlteracaoNome',
    nome: 'Pedido de Alteração de Nome',
    categoria: 'pedidos',
    descricao: 'Solicitação de alteração de nome',
    icon: 'FaEdit',

    documentConfig: {
        required: [
            {
                id: 'requerimento', tipoDocumentoProcesso: 433,
                name: 'Requerimento',
                description: 'Requerimento preenchido e assinado digitalmente',
                required: true
            },
            {
                id: 'CopiaDigitalizadoRG', tipoDocumentoProcesso: 533,
                name: 'Cópia Digitalizada do RG',
                description: 'Cópia digitalizada do RG atualizado, evidenciando a alteração de nome',
                required: true
            },
            {
                id: 'certidaoCasamento/averbacao', tipoDocumentoProcesso: 103,
                name: 'Certidão de Casamento/Averbação',
                description: 'Certidão de casamento ou averbação de alteração de nome',
                required: true
            }
        ],
    },

    paymentConfig,
    protocoloConfig,
    tituloConfig,
    dadosRequerimentoConfig,

    steps: [
        {
            id: 'dados_pessoais',
            title: 'Dados Pessoais',
            sections: [
                {
                    title: 'Identificação do Requerente',
                    fields: [
                        {
                            type: 'text',
                            name: 'nomeCompleto',
                            label: 'Nome completo',
                            required: true,
                            placeholder: 'Digite seu nome completo'
                        },
                        {
                            type: 'cpf',
                            name: 'cpf',
                            label: 'CPF',
                            required: true
                        }
                    ]
                },
                {
                    title: 'Tipo de Serviço para Alteração de Nome',
                    fields: [
                        {
                            type: 'radio',
                            name: 'tipoServicoAlteracaoNome',
                            label: 'Selecione o tipo de serviço desejado',
                            required: true,
                            options: [
                                {
                                    value: 'CARTÃO_NOVO_CARTEIRA_NOVA',
                                    label: 'Cartão Novo + Carteira Nova - R$ 164,00',
                                    description: 'Emissão de novo cartão com carteira nova'
                                },
                                {
                                    value: 'CARTÃO_NOVO_AVERBAÇÃO',
                                    label: 'Cartão Novo + Averbação na Carteira (Brochura) - R$ 140,00',
                                    description: 'Averbação na carteira existente (brochura)'
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        enderecoStep({ autoCep: true }),
        termosStep()
    ]
};

export default pedidoAlteracaoNomeConfig;